<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" depressed v-on="on">
        <v-icon left>add</v-icon>New Skill
      </v-btn>
    </template>
    <v-card>
      <v-form ref="form">
        <v-card-title>
          <span class="headline">Create Skill</span>
        </v-card-title>
        <v-card-text>
          <v-alert
            v-show="!!error"
            text
            prominent
            type="error"
            icon="mdi-alert-circle"
            >{{ error }}</v-alert
          >
          <v-alert
            v-show="!!success"
            text
            prominent
            type="success"
            icon="mdi-cloud-check"
            >Succesfully Created</v-alert
          >
          <v-container class="text-center" v-if="loading">
            <v-progress-circular
              :size="70"
              :width="7"
              color="purple"
              indeterminate
            ></v-progress-circular>
          </v-container>
          <v-container v-else>
            <v-row>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="item.Name"
                  label="Name"
                  required
                  :rules="nameRules"
                  maxlength="50"
                  counter
                  :disabled="success"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="12">
                <v-text-field
                  v-model="item.Code"
                  label="Code"
                  required
                  :rules="codeRules"
                  maxlength="50"
                  counter
                  :disabled="success"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            color="primary"
            v-show="!success && !loading"
            @click="save"
            >Save</v-btn
          >
          <v-btn color="grey darken-1" text @click="toggleDialog">Cancel</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import {
  CREATE_SKILL,
  TOGGLE_CREATE_SKILL_DIALOG,
} from "../../store/modules/digistaff";

export default {
  props: ["digistaffId"],
  data: () => ({
    item: {
      Name: "",
      Code: "",
    },
    nameRules: [(v) => !!v || "Name is required"],
    codeRules: [(v) => !!v || "Code is required"],
  }),
  computed: {
    dialog: {
      get() {
        return this.$store.state.digistaff.createSkill.dialog;
      },
      set() {
        this.toggleDialog();
      },
    },
    ...mapState("digistaff", {
      loading: (state) => state.createSkill.isLoading,
      success: (state) => state.createSkill.success,
      error: (state) => state.createSkill.error,
    }),
  },
  methods: {
    ...mapActions("digistaff", {
      createSkill: CREATE_SKILL,
      toggleDialog: TOGGLE_CREATE_SKILL_DIALOG,
    }),
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.createSkill({ digistaffId: this.digistaffId, skill: this.item });
    },
  },
};
</script>
